import { render, staticRenderFns } from "./LoanRequestHistory.vue?vue&type=template&id=0b6bf240&scoped=true&"
import script from "./LoanRequestHistory.vue?vue&type=script&lang=js&"
export * from "./LoanRequestHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6bf240",
  null
  
)

export default component.exports